<template>
  <div class="new commande" :class="{ valid }">
    <div class="operations">

      <div class="resume">
    <h2 class="uid length">{{ uid }}/{{ menus.length }}</h2>
    <h2 class="total">Total: {{ total }}€</h2>
    <h2 class="rabais">Rabais: {{ rabais }}€</h2>
        <button @click="inc(rabais)">+</button>
        <button @click="zero()">0</button>
      </div>
      <button class="big add" @click="addMenu">+</button>
      <button class="big save" :disabled="!valid" @click="saveCommande">sauver</button>
    </div>
    <div class="menus">
      <ul>
        <li v-for="([menu, i]) in indexedReversed(menus)" :key="menu.uid">
          <Menu :menu="menu" :idx='i' :set='set' @kill="kill" @raz="raz" @dup="dup"
                @setBoisson="setBoisson"
                @setViande="setViande"></Menu>
        </li>
      </ul>
    </div>
    <client @setClient="setClient"></client>
  </div>
</template>
<script>

import _ from 'lodash';
import { suck } from '@/lib/prelude.js'
import * as menu from '@/models/menu.js'
import * as clientAPI from '@/models/client.js'
import { store } from '@/lib/databases.js'
import { empty, uid, price, valid, indexedReversed } from '@/models/commande.js'
import Client from '@/components/client/Client.vue'
import Menu from '@/components/menu/Menu.vue'

const mlet = (fn, err) => {
    return (g) => {
        let v = fn();
        if (v) {
            return g(v);
        } else {
            return err(v);
        }
    }
}

export default {
    name: 'nouvelleCommande',
    components: { Menu, Client, },
    computed: {
        valid () { return valid(this); },
        indexedReversed () { return indexedReversed },
        total () { return price(this)['apayer']; },
        uid () { return uid(this.date); },
        vrabais: {
            get() { return this.rabais },
            set(newValue) {
                if (newValue.length >= 0) {
                    try { this.rabais = menu.updateRabais(newValue) }
                    catch (e) { console.log(e) }
                }
            }
        }
    },

    methods: {
        addMenu () { this.menus.push(menu.empty());    },
        setClient (e) { Object.assign(this.client, e); },
        saveCommande () {
         let commande = suck(empty(), this, 'uid')
         let { uid } = commande
         let client = suck(clientAPI.empty(), commande.client)
         store(this.$db, commande, client)
           .then(result => {
              let {storeAction, data} = result
              console.log('vue save action', storeAction, data);
              if (storeAction === 'conflict') {
                let { stored, client } = data
                let msg = `Attention
    Un client existant (${stored.nom})
    a deja ce numero ${client.numero}
    mais un nom different de (${client.nom}).
    Options:
    - Changer le numero dans le formulaire
    - Demander des precision au client actuel`
                alert(msg)
                throw result
              } else if (storeAction === 'orderAndClient') {
                let { client: { nom, numero } } = data
                this.$toasted.show(`Nouveau client: ${nom} ${numero}`, {duration: 1000})
              }
              this.$toasted.show(`Nouvelle commande ${uid}`, {duration: 1000})
            })
           .then(() => this.$router.push({ path: `/ticket/${uid}`}))
           .catch(console.log);
          },
        inc() { this.rabais = menu.incRabais(this.rabais) },
        dec() { this.rabais = menu.decRabais(this.rabais) },
        zero() { this.rabais = menu.zeroRabais() },
        set ({k, uid, nuw}) {
            let getMenu = () => _.find(this.menus, { uid })
            let error = () => { console.log('menu', uid, 'not found', 'CRITICAL'); }
            let setAny = (m) => { m[k] = nuw; console.log(`${uid}.${k} = ${nuw}`); }
            mlet(getMenu, error)(setAny)
        },
        raz (uid) {
            let idx = _.findIndex(this.menus, (m) => m.uid === uid)
            // findIndex does not return a falsy value, cannot use mlet.
            if (idx != -1) {
                let m = this.menus[idx]
                menu.zero(m)
                console.log('raz', idx, uid);
            } else {
                console.log('menu', uid, 'not found', 'CRITICAL');
            }
        },
        dup (uid) {
            let getMenu = () => _.find(this.menus, { uid })
            let m = getMenu()
            if (m) {
                console.log('duplicating menu', uid)
                this.menus.push(menu.clone(m))
            } else {
                let error = () => { console.log('menu', uid, 'not found', 'CRITICAL'); }
                error()
            }
        },
        setViande ({ uid, counted, delta }) { 
            let getMenu = () => _.find(this.menus, { uid })
            let error = () => { console.log('menu', uid, 'not found', 'CRITICAL'); }
            let setV = (m) => {
                let { item } = counted;
                menu.updateViande(m, item, delta); console.log('co.viandes', uid, counted);
            }
            mlet(getMenu, error)(setV)
        },
        setBoisson ({ uid, counted }) {
            let getMenu = () => _.find(this.menus, { uid })
            let error = () => { console.log('menu', uid, 'not found', 'CRITICAL'); }
            let setB = (m) => {
                let { item : { nom } } = counted;
                m.boissons[nom] = counted ; console.log('co.boissons', uid, counted);
            }
            mlet(getMenu, error)(setB)
        },
        kill (uid) {
            let getMenu = () => _.find(this.menus, { uid })
            let error = (m) => console.log('commande.kill', uid, m, this.menus.length)
            let kill = () => { this.menus = _.filter(this.menus, (o) => o.uid != uid) }
            mlet(getMenu, error)(kill)
        },
    },
    data () {
        let commande = empty();
        commande.menus.push(menu.empty());
        return commande;
    }
}
</script>
<style>

.menus ul { padding : 0; }
.menus li { list-style: none; margin-top: 4px; }
.menus li:first-child { margin-top: 0; }

.operations {
display: grid;
align-items: initial;
grid-template-columns: 2fr 1.5fr 1.5fr;
gap: 0.2em;
height: 11em;
}

.operations .rabais button {
padding: 0;
margin: 0 4px;
}

.rabais button {
padding: 0;
margin: 0;
width: 1em;
}

label[for="rabais"] {
border: thin solid
#ececec;

display: inline-block;

padding: 5px;

border-radius: 0 4px 4px 0;

font-size: 14px;

background-color: #ececec;
    bottom: 2px;
    position: relative;

}

.commande {
align-items: start;
gap: 4px;
}

.commande button { min-height: 3em; }

@media only screen and (min-width: 600px) {

  .commande {
    display: grid;
    gap: 0.2em;
    grid-template-columns: 2fr 4fr 2fr;
  }

  .commande h1 {
  }

  .commande ul { padding: 0; margin:0; }

  .operations button {}

}

@media only screen and (max-width: 400px) {

  .commande {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }

  .commande h1 {
  }

  .commande ul { padding: 0; margin:0; }

  .operations button { margin-right: 0px; }

  .rabais ~ button { margin-right: 0 !important; }

}

.add {
background-color:pink;
}

.save {
background-color:palegreen;
}

.save:disabled {
background-color: #eee;
}

.resume {
padding: 8px;
background-color: lavender;
display: grid;
border: thick solid #5f9ea01c;
grid-template-areas: "uid uid"
                     "total total"
                     "rabais rabais"
                     "rops rops";
}

.operations h2 { margin: 2px }

.uid { grid-area: uid }
.total { grid-area: total }
.rabais { grid-area: rabais }

.big {
font-weight: bold;
font-size: 20pt;
}

</style>
